/* eslint-disable react/prop-types */
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './styles.css';
import ReactLinkify from 'react-linkify';


function ModalDetalheMensagem({ isOpen, toggle, message, onMarkAsUnread  }) {
  if (!message) {
    return null;
  }

  const handleButtonClick = () => {
    onMarkAsUnread(message._id);
  };


  const formattedDate = new Date(message.createdAt?.$date || message.createdAt).toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });

  const linkProperties = (href, text, key) => (
    <a href={href} key={key} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Mensagem
      </ModalHeader>
      <ModalBody>
        <h5>{message.title}</h5>
        <ReactLinkify componentDecorator={linkProperties}>
          <p style={{ whiteSpace: 'pre-wrap' }}>{message.body}</p>
        </ReactLinkify>
        <hr />
        <small className="text-muted">
          Recebido em: {formattedDate}
        </small>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleButtonClick}>
          Marcar como não lida
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalDetalheMensagem;